import { useEffect, useRef } from 'react'

/**
 * Returns the previous value of a variable
 */
export const usePrevious = <T>(value: T) => {
	const ref = useRef<T>()

	useEffect(() => {
		ref.current = value
	}, [value])

	return ref.current
}
